import messages from "./messages"
import tracker from "../common/tracker"
import Source from "../interview/Source"
import DashboardSource from "../dashboard/Source"
import * as t from "./actionTypes"
import * as generator from "../chatItemGenerator"
import * as interviewActions from "../interview/actions"
import * as completionActions from "../completion/actions"
import * as dashboardActions from "../dashboard/actions"
import { setterAction } from "../common/redux"
import { captureException } from "../common/error"
import { getUserCharges } from "../payment/actions"

export const setDidCaptureLocation = setterAction(t.SET_DID_CAPTURE_LOCATION)
export const setZipcode = setterAction(t.SET_ZIPCODE)
export const setZipcodeError = setterAction(t.SET_ZIPCODE_ERROR)
export const setRecommendations = setterAction(t.SET_RECOMMENDATIONS)
export const setCardIdentifier = setterAction(t.SET_CARD_IDENTIFIER)
export const showEmailModal = setterAction(t.SHOW_EMAIL_MODAL)
export const setCanUpdateInsurance = setterAction(t.SET_CAN_UPDATE_INSURANCE)
export const setConfiguredExperience = setterAction(t.SET_CONFIGURED_EXPERIENCE)
export const setConfiguredPlanProvider = setterAction(t.SET_CONFIGURED_EXPERIENCE)
export const setEmployer = setterAction(t.SET_EMPLOYER)
export const setMarketplaceToken = setterAction(t.SET_MARKETPLACE_TOKEN)
export const setSpecialist = setterAction(t.SET_SPECIALIST)
export const setDiagnosisConcernSearch = setterAction(
  t.SET_DIAGNOSIS_CONCERN_SEARCH
)
export const setDiagnosisConcernRecommendations = setterAction(
  t.SET_DIAGNOSIS_CONCERN_REC
)
export const setInsuranceMessages = setterAction(t.SET_INSURANCE_MESSAGES)

export const getVisitRecommendations = () => (dispatch, getState) => {
  let { integration, brand, completion, dashboard, feedback } = getState()
  let { planInformation } = dashboard
  const { diagnosisConcern } = feedback
  const { isAlarm } = completion

  let query = {
    marketplace: integration.marketplaceToken
      ? integration.marketplaceToken
      : brand.token,
  }

  if (planInformation) {
    const planInfo = {
      office: planInformation.office,
      plan: planInformation.plan,
      // Using underscores to convert easily to actual params using qs
      plan_provider: planInformation.plan_provider,
      plan_holder: planInformation.plan_holder,
    }
    query = { ...query, ...planInfo }
  }

  if (diagnosisConcern.display && !isAlarm) {
    Source.visitDiagnosisOfConcernRecommendations(query)
      .then(data => {
        dispatch(
          setDiagnosisConcernRecommendations(
            data.recommendations.diagnosis_of_concern
          )
        )
      })
      .catch(captureException)
  }

  dispatch(getUserCharges())
  dispatch(
    interviewActions.setLoading(true, "integration/getVisitRecommendations")
  )
  navigator.geolocation.getCurrentPosition(
    position => {
      dispatch(
        submitLocation({
          location_type: "coordinate",
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        })
      )
    },
    error => {
      if (error.code === 3) {
        // Timeout due to device error
        tracker.locationTimeout()
      }
      Source.getVisitRecommendations(query)
        .then(data => {
          let intsFound =
            data &&
            data.recommendations &&
            Object.keys(data.recommendations).length > 0
          if (intsFound) {
            Object.entries(data.recommendations).forEach(
              (recommendationSection, sectionKey) => {
                recommendationSection.forEach(recommendation => {
                  tracker.shownRecommendation(
                    query.marketplace,
                    recommendation.name,
                    recommendation.token
                  )
                })
              }
            )
            dispatch(setRecommendations(data.recommendations))
          }
          dispatch(interviewActions.setLoading(false))
          dispatch(completionActions.showResults())
        })
        .catch(error => {
          dispatch(interviewActions.setLoading(false))
          dispatch(completionActions.showResults())
          captureException(error)
        })
    },
    window.geo_timeout_ab_test
      ? { timeout: window.geo_timeout_ab_test }
      : undefined
  )
}

export const submitLocationZip = () => (dispatch, getState) => {
  let { zipcode } = getState().integration
  if (zipcode.length) {
    dispatch(
      submitLocation(
        { location_type: "postal_code", postal_code: zipcode },
        true
      )
    )
  }
}

export const updateVisitRecommendations = () => (dispatch, getState) => {
  let { integration, brand, dashboard } = getState()
  let { planInformation } = dashboard

  let query = {
    marketplace: integration.marketplaceToken
      ? integration.marketplaceToken
      : brand.token,
  }

  if (planInformation) {
    const planInfo = {
      office: planInformation.office,
      plan: planInformation.plan,
      // Using underscores to convert easily to actual params using qs
      plan_provider: planInformation.plan_provider,
      plan_holder: planInformation.plan_holder,
    }
    query = { ...query, ...planInfo }
  }

  return Source.getVisitRecommendations(query).then(data => {
    let recommendationsFound = data && data.recommendations && Object.keys(data.recommendations).length > 0
    if (recommendationsFound) {
      Object.entries(data.recommendations).forEach(
        (recommendationSection, recommendationKey) => {
          recommendationSection.forEach(recommendation => {
            tracker.shownRecommendation(
              query.marketplace,
              recommendation.name,
              recommendation.token
            )
          })
        }
      )
      dispatch(setRecommendations(data.recommendations))
    }
  })
}

export const submitLocation = (location, resubmit = false) => (
  dispatch,
  getState
) => {
  let { integration, brand, dashboard } = getState()
  let { zipcode } = integration
  let { planInformation } = dashboard

  let query = {
    marketplace: integration.marketplaceToken
      ? integration.marketplaceToken
      : brand.token,
  }

  if (planInformation) {
    const planInfo = {
      office: planInformation.office,
      plan: planInformation.plan,
      // Using underscores to convert easily to actual params using qs
      plan_provider: planInformation.plan_provider,
      plan_holder: planInformation.plan_holder,
    }
    query = { ...query, ...planInfo }
  }

  dispatch(interviewActions.setLoading(true, "integration/submitLocation"))
  Source.submitLocation(location)
    .then(data => {
      dispatch(setDidCaptureLocation(true))
      dispatch(setZipcodeError(null))
      if (!zipcode.length) {
        dispatch(setZipcode(data.postal_code))
      }
      return Source.getVisitRecommendations(query)
    })
    .then(data => {
      let recommendationsFound =
        data &&
        data.recommendations &&
        Object.keys(data.recommendations).length > 0
      if (recommendationsFound) {
        Object.entries(data.recommendations).forEach(
          (recommendationSection, recommendationKey) => {
            recommendationSection.forEach(recommendation => {
              tracker.shownRecommendation(
                query.marketplace,
                recommendation.name,
                recommendation.token
              )
            })
          }
        )
        dispatch(getRegionBasedInsuranceMessages())
        dispatch(setRecommendations(data.recommendations))
      }

      dispatch(interviewActions.setLoading(false))

      if (!resubmit) {
        dispatch(completionActions.showResults())
      }
    })
    .catch(error => {
      // Handle bad zipcodes (and 400s generally) seperate from other errors.
      // Prevents Sentry from popping up in these situations.
      let errorMsg = undefined
      try {
        if (error.response && error.response.data && error.response.data.msg) {
          errorMsg = error.response.data.msg
        }
      } catch (e) {
        errorMsg = e
      }
      dispatch(setZipcodeError(errorMsg || ""))
      if (error.response && error.response.status !== 400) {
        captureException(errorMsg)
      }
      dispatch(interviewActions.setLoading(false))
      if (!resubmit) {
        dispatch(completionActions.showResults())
      }
    })
}

export const initInsuranceCapture = () => (dispatch, getState) => {
  const { planInformation } = getState().dashboard
  const { marketplaceToken, canUpdateInsurance } = getState().integration

  if (!canUpdateInsurance) {
    // skipping employer/insurance questions for configured experience.
    dispatch(employerCaptureExit())
  } else if (planInformation) {
    // has submitted provider
    if (marketplaceToken.trim()) {
      // skip employer question if marketplace already set
      dispatch(employerCaptureExit())
    } else {
      tracker.employerCapture.init()
      dispatch(
        interviewActions.addChatItems([
          generator.systemMessage(messages.employerCapture.opener1()),
          generator.systemMessage(messages.employerCapture.opener2()),
          generator.employerCaptureIntro(),
        ])
      )
    }
  } else {
    tracker.insuranceCapture.init()
    dispatch(
      interviewActions.addChatItems([
        generator.systemMessage(messages.insuranceCapture.opener1()),
        generator.systemMessage(messages.insuranceCapture.opener2()),
        generator.insuranceCapture(),
      ])
    )
  }
}

export const insuranceCaptureSubmitProvider = selected => (
  dispatch,
  getState
) => {
  const { planInformation } = getState().dashboard
  const { brand } = getState().custom
  let office,
    planProvider,
    plan = null
  const submitPlan = planInformation
    ? DashboardSource.updatePlanInformation
    : DashboardSource.submitPlanInformation

  return DashboardSource.getOffices(brand ? brand.owner : "Buoy")
    .then(data => {
      office = data.find(d => d.address === "Public").token
      return DashboardSource.getPlanProviders(office)
    })
    .then(data => {
      planProvider =
        data.length &&
        data.find(d => d.name === selected || d.token === selected)
      planProvider = planProvider ? planProvider.token : null
      return DashboardSource.getPlans(office, planProvider)
    })
    .then(data => {
      plan = data[0]
      return submitPlan(office, plan.token, "SE")
    })
    .then(data => {
      return dispatch(dashboardActions.setPlanInformation(data))
    })
}

export const insuranceCaptureResponse = response => dispatch => {
  tracker.insuranceCapture.submitProvider(response.text)
  dispatch(employerInsuranceCaptureTransition(response))
  dispatch(insuranceCaptureSubmitProvider(response.token)).catch(error => {
    captureException(error)
  })
}

const employerInsuranceCaptureTransition = response => dispatch => {
  // set provider response and init employer capture if request fetching plans fails
  // do not ask employer capture question if user selected not insured for insurance capture
  dispatch(interviewActions.addChatItem(generator.response(response.text)))
  if (response.token === "Not Insured") {
    dispatch(employerCaptureExit())
  } else {
    dispatch(initEmployerCapture())
  }
}

export const initEmployerCapture = () => (dispatch, getState) => {
  const { marketplaceToken } = getState().integration

  if (marketplaceToken.trim()) {
    // Already has a saved marketplace, skip asking for one.
    dispatch(employerCaptureExit())
  } else {
    // No saved marketplace, we should prompt for one.
    tracker.employerCapture.init()
    dispatch(interviewActions.addChatItems([generator.employerCaptureIntro()]))
  }
}

export const employerIntroResponse = response => (dispatch, getState) => {
  if (response.token === "Yes") {
    tracker.employerCapture.optIn()
    dispatch(
      interviewActions.addChatItems([
        generator.response(response.text),
        generator.employerCaptureInput(),
      ])
    )
  } else {
    tracker.employerCapture.introOptOut(response.text)
    dispatch(
      interviewActions.addChatItems([
        generator.response(response.text),
        generator.systemMessage(messages.employerCapture.optOut()),
      ])
    )
    dispatch(employerCaptureExit())
  }
}

export const employerInfoSubmit = () => (dispatch, getState) => {
  const { integration, identifiers } = getState()
  const { employer } = integration
  const { profile_id } = identifiers

  if (employer) {
    Source.captureEmployer(profile_id, employer)
      .then(data => {
        tracker.employerCapture.employerProvided(employer)
        dispatch(setMarketplaceToken(data.marketplace_token))
        dispatch(
          interviewActions.addChatItems([
            generator.response(employer),
            generator.systemMessage(
              messages.employerCapture.closer(data.marketplace_token)
            ),
          ])
        )
      })
      .catch(captureException)
  } else {
    tracker.employerCapture.inputOptOut()
    dispatch(
      interviewActions.addChatItems([
        generator.response("Skip"),
        generator.systemMessage(messages.employerCapture.optOut()),
      ])
    )
  }
  dispatch(employerCaptureExit(employer))
}

export const employerCaptureExit = () => (dispatch, getState) => {
  let { results, isAlarm } = getState().completion
  dispatch(interviewActions.setLoading(true, "integration/employerCaptureExit"))
  setTimeout(() => {
    dispatch(interviewActions.setLoading(false))
    tracker.completion(results.differential.length, isAlarm)
    dispatch(getVisitRecommendations())
  }, 3000)
}

export const getUserEmployer = profile_id => dispatch => {
  Source.getEmployer(profile_id)
    .then(data => {
      dispatch(setMarketplaceToken(data.marketplace_token))
    })
    .catch(captureException)
}

export const getRegionBasedInsuranceMessages = () => dispatch => {
  Source.getRegionBasedInsuranceMessages()
    .then(data => {
      dispatch(setInsuranceMessages(data.messages))
    })
    .catch(captureException)
}



// WEBPACK FOOTER //
// ./assets/integration/actions.js